import { ReactNode } from "react";
import GoogleIcon from "../primary/Icon";

export type ServiceSummary = {
  title: string;
  summary: string;
  slug: string;
  icon: ReactNode;
};

export const serviceSummaries: ServiceSummary[] = [
  {
    icon: <GoogleIcon name="groups" fontSize={32} color="currentColor" />,
    title: "Belonging",
    slug: "belonging",
    summary: "Condition for meaningful engagement",
  },
  {
    icon: <GoogleIcon name="bolt" fontSize={32} color="currentColor" />,
    title: "Agency",
    slug: "agency",
    summary: "How people move beyond participation to shape the shared space",
  },
  {
    icon: <GoogleIcon name="share" fontSize={32} color="currentColor" />,
    title: "Relatedness",
    slug: "relatedness",
    summary: "Connecting learning to lived experience",
  },
];
